import React, { useMemo } from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { withTranslate } from 'components/hocs';
import { renderSelect } from 'components/form-components';

import classes from './LoginFieldsGroup.module.scss';

const renderField = ({
  input,
  label,
  type = 'text',
  meta: { touched, error },
  translate,
  ...otherProps
}) => {
  const errorMessage =
    typeof error === 'object'
      ? translate(error.stringNumber, error.message)
      : error;
console.log('renderField otherProps: ',otherProps)
  return (
    <div
      className={classnames(classes.inputGroup, {
        [classes.errorState]: !!(touched && errorMessage),
      })}
    >
      {!otherProps.product?.onePerson &&
      <input {...input} {...otherProps} type={type} placeholder={label}/>
      }
      
      {otherProps.product?.onePerson && otherProps?.options?.length &&
      <input {...input} {...otherProps} type={type} placeholder={label} value={otherProps.options[0].value}/>
      }
      
      {/*touched && errorMessage && (
        <span className={classes.error}>{errorMessage}</span>
      )*/}
    </div>
  );
};

const renderSelectField = (props) => {
  const {
    defaultMenuIsOpen,
    isClearable = true,
    noOptionsText,
    mobileWrapperLandscape = false,
    ...selectProps
  } = props;
  const SelectComponent = renderSelect;
  const familyLoginSelectStyles = mobileWrapperLandscape ? {
    control: base => ({
      ...base,
      minHeight: 'clamp(36px, 8.4vh, 52px)',
      borderRadius: 'clamp(18px, 4vh, 27px)',
      borderColor: '#c9c9c9',
      boxShadow: 'none',
      backgroundColor: '#fff',
      fontSize: 'clamp(14px, 3.2vh, 20px)',
      '&:hover': { borderColor: '#c9c9c9' },
    }),
    valueContainer: base => ({ ...base, padding: '0 clamp(12px, 1.8vw, 20px)' }),
    menu: base => ({ ...base, zIndex: 10020, fontSize: 'clamp(13px, 3.2vh, 17px)' }),
    menuPortal: base => ({ ...base, zIndex: 10020 }),
  } : {
    control: base => ({
      ...base,
      borderRadius: '1.5vw',
    })
  };

  // Mobile Login uses a body portal so the empty Family/Friends message can
  // render above the bottom Global Button panel instead of being clipped by
  // the Login page stacking context. Desktop keeps its original select path.
  return (
    <SelectComponent
      {...selectProps}
      marginBottom='0'
      isSearchable={false}
      blurInputOnSelect={false}
      styles={familyLoginSelectStyles}
      defaultMenuIsOpen={typeof defaultMenuIsOpen === 'boolean' ? defaultMenuIsOpen : props.input.name === 'username'}
      isClearable={isClearable}
      noOptionsMessage={() => noOptionsText || 'No options'}
      menuPortalTarget={mobileWrapperLandscape && typeof document !== 'undefined' ? document.body : undefined}
      menuPosition={mobileWrapperLandscape ? 'fixed' : 'absolute'}
      menuPlacement={mobileWrapperLandscape ? 'auto' : 'bottom'}
    />
  );
}

//const LoginFieldsGroup = ({ number, primary, translate, family, learningCenter, noTitle, product, instructionsData }) => {
  const LoginFieldsGroup = ({ 
  number, 
  primary, 
  translate, 
  family, 
  learningCenter, 
  noTitle, 
  product, 
  instructionsData,
  titleOverride,
  defaultMenuIsOpen,
  autoFocus,
  locked = false,
  noOptionsText,
  mobileWrapperLandscape = false,
}) => {

  const isFamilyLogin = !!family.id;

  const fieldComponent = isFamilyLogin && !product?.onePerson ? renderSelectField : renderField;
  /*const familyLoginsValues = useMemo(() => {
    console.log('LoginFieldsGroup family.members: ',family.members)*/
    const familyLoginsValues = useMemo(() => { 
    return isFamilyLogin ? family.members
    .filter(m => !product?.onePerson || m.firstname !== "First")
    .map(m => ({
      label: m.firstname,
      value: m.username,
    })) : product?.onePerson && instructionsData?.username ? [{
      label: instructionsData.username,
      value: instructionsData.username,
    }] : null;
  }, [isFamilyLogin, family, product, instructionsData]);

  const loginGroupClasses = classnames(classes.loginGroup, {
    [classes.familyLogin]: isFamilyLogin,
    [classes.mobileWrapperLandscape]: mobileWrapperLandscape,
  });

  const loginGroupTitle = family.members.length
    ? translate(537, 'Family member')
    : translate(2922, 'Team member');

  return (
    <div className={loginGroupClasses}>
      {!noTitle && (
        <b className={classes.loginGroupTitle}>
          {titleOverride || (
            <>
              {loginGroupTitle} #{primary ? 1 : number}
            </>
          )}
        </b>

      )}

      <Field
        name={`username${primary ? '' : number}`}
        autoFocus={typeof autoFocus === 'boolean' ? autoFocus : primary}
        defaultMenuIsOpen={defaultMenuIsOpen}
        component={fieldComponent}
        options={familyLoginsValues}
        isClearable={!locked}
        isDisabled={locked}
        noOptionsText={noOptionsText}
        mobileWrapperLandscape={mobileWrapperLandscape}
        label={!isFamilyLogin ? translate(102, 'Username') : null}
        translate={translate}
        product={product}
      />

      {(!isFamilyLogin && !learningCenter && primary) && (<Field
        name={`password${primary ? '' : number}`}
        type="password"
        component={renderField}
        label={translate(103, 'Password')}
        translate={translate}
      />) }
    </div>
  );
};

LoginFieldsGroup.propTypes = {
  number: PropTypes.string,
  primary: PropTypes.bool,
  family: PropTypes.object.isRequired,
  product: PropTypes.object,
  instructionsData: PropTypes.object,
  titleOverride: PropTypes.node,
  defaultMenuIsOpen: PropTypes.bool,
  autoFocus: PropTypes.bool,
  locked: PropTypes.bool,
  noOptionsText: PropTypes.string,
  mobileWrapperLandscape: PropTypes.bool,
};

export default withTranslate(LoginFieldsGroup);
